import { cx } from "../../lib/cx.js";
import { Icon } from "../Icon/Icon.js";
import { VisuallyHidden } from "../VisuallyHidden/VisuallyHidden.js";
/* empty css            */
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Spinner/Spinner.tsx
/**
* A spinning loader for work in progress, in the current text colour. It announces its
* `label` as a status; under reduced motion it stays still. Prefer a label change with
* the width kept (Button's `loadingText`) for an action, and Skeleton for content.
*/
function Spinner({ size = "md", label = "Loading", onPrimary: _onPrimary, className, ...rest }) {
	const decorative = label === "";
	return /* @__PURE__ */ jsxs("span", {
		className: cx("ds-spinner", size !== "md" && `ds-spinner--${size}`, className),
		...decorative ? { "aria-hidden": true } : { role: "status" },
		...rest,
		children: [/* @__PURE__ */ jsx(Icon, { name: "loader" }), !decorative && /* @__PURE__ */ jsx(VisuallyHidden, { children: label })]
	});
}
//#endregion
export { Spinner };

//# sourceMappingURL=Spinner.js.map